import useLocalStore from '../../../hooks/useLocalStore.js';
import { useSelector } from 'react-redux';
import FJConstant from '../../../constants/FJConstant.js';
import FJCommunityHomeContainer from './FJCommunityHome/FJCommunityHomeContainer.jsx';
import FJCommunityListContainer from './FJCommunityList/FJCommunityListContainer.jsx';
import FJCommunityMySpaceContainer from './FJCommunityMySpace/FJCommunityMySpaceContainer.jsx';
import FJCommunityAIToolsContainer from './FJCommunityAITools/FJCommunityAIToolsContainer.jsx';

const FJCommunityRightContainer = () => {
    useLocalStore();
    const navBarTab = useSelector(state => state.community.navBarTab);
    const isLoadedPage = useSelector(state => state.community.isLoadedPage);
    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {isLoadedPage.home && <FJCommunityHomeContainer active={navBarTab === FJConstant.HOME} />}
            {isLoadedPage.community && <FJCommunityListContainer active={navBarTab === FJConstant.COMMUNITY} />}
            {isLoadedPage.aiTools && <FJCommunityAIToolsContainer active={navBarTab === FJConstant.AI_TOOL_LIST} />}
            {isLoadedPage.mySpace && <FJCommunityMySpaceContainer active={navBarTab === FJConstant.MY_SPACE} />}
        </div>
    );
};

export default FJCommunityRightContainer;
